<div class="left-nav has-shadow">
    <nav [class.expanded]="expanded === true">
        <div class="flex flex-column overflow-x-hidden overflow-y-auto h-screen">
            <div class="flex flex-row sm:flex-column justify-content-evenly sm:pl-0 pl-3 pr-3 sm:pr-0">
                <a class="hidden menu-toggle sm:flex align-items-center" (click)="toggleSize()">
                    <i
                        class="fas"
                        [class.fa-bars]="expanded === false"
                        [class.fa-arrow-to-left]="expanded === true"
                        [class.fa-border]="expanded === true"
                    ></i>
                </a>
                <a routerLink="/map" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <svg width="16" height="16" viewBox="0 0 600 600">
                            <circle class="logo-color1" cx="100" cy="100" r="80" />
                            <circle class="logo-color1" cx="100" cy="300" r="80" />
                            <circle class="logo-color1" cx="100" cy="500" r="80" />
                            <circle class="logo-color1" cx="300" cy="100" r="80" />
                            <circle class="logo-color2" cx="300" cy="300" r="80" />
                            <circle class="logo-color1" cx="300" cy="500" r="80" />
                            <circle class="logo-color2" cx="500" cy="100" r="80" />
                            <circle class="logo-color2" cx="500" cy="300" r="80" />
                            <circle class="logo-color1" cx="500" cy="500" r="80" />
                        </svg>
                    </div>
                    <span class="block sm:inline">Maps</span>
                </a>
                @if(isEditorEnabled && (isAdmin || isOwner)){
                <a routerLink="/editor" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-globe-wifi"></i>
                    </div>
                    <span class="block sm:inline">Editor</span>
                </a>
                }
                <a routerLink="/floors" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-layer-group"></i>
                    </div>
                    <span class="block sm:inline">Floors</span>
                </a>
                @if(isZonesEnabled){
                <a routerLink="/layers" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-object-ungroup"></i>
                    </div>
                    <span class="block sm:inline">Layers</span>
                </a>
                } @if(isAnalyticsEnabled){
                <a routerLink="/analytics" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-chart-simple"></i>
                    </div>
                    <span class="block sm:inline">Analytics</span>
                </a>
                }
                <a routerLink="/report" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-file-chart-line"></i>
                    </div>
                    <span class="block sm:inline">Reports</span>
                </a>
                @if(isIntelligenceEnabled){
                <a routerLink="/intelligence" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-sparkles"></i>
                    </div>
                    <span class="block sm:inline">Intelligence</span>
                </a>
                }
                <a routerLink="/settings" routerLinkActive="active" class="menu-link text-center pl-4 pr-4 sm:pr-0">
                    <div class="icon">
                        <i class="fas fa-fw fa-cog"></i>
                    </div>
                    <span class="block sm:inline">Settings</span>
                </a>
                <a class="menu-link flex sm:hidden text-center pl-4 pr-4 sm:pr-0" (click)="logout()">
                    <div class="icon">
                        <i class="fas fa-fw fa-sign-out"></i>
                    </div>
                    <span class="block sm:inline">Logout</span>
                </a>
            </div>
            <div class="flex flex-column mt-auto align-self-stretch">
                <a class="menu-link text-center pl-4 pr-4 sm:pr-0" (click)="toggleDarkMode()">
                    <div class="icon">
                        <i class="fas fa-circle-half-stroke"></i>
                    </div>
                    <span class="block sm:inline">Dark/Light Mode</span>
                </a>
                <a class="menu-link text-center pl-4 pr-4 sm:pr-0" (click)="logout()">
                    <div class="icon">
                        <i class="fas fa-fw fa-sign-out"></i>
                    </div>
                    <span class="block sm:inline">Logout</span>
                </a>
                <div class="logo flex justify-content-center flex-column mt-4">
                    @if (expanded) {
                    <div class="text-center">
                        @if (self()) {
                        <small class="color-text-medium white-space-nowrap">
                            Logged in as {{ self()!.firstName }} {{ self()!.lastName }}
                        </small>
                        }
                    </div>
                    }
                    <div>
                        @if (!expanded) {
                        <img src="/assets/svg/logomark_purple.svg" />
                        } @if (expanded) { @if(theme() === 'dark'){
                        <img src="/assets/svg/logo_horizontal_dark_2.svg" />
                        } @else {
                        <img src="/assets/svg/logo_horizontal_light.svg" />
                        } }
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>
<p-confirmdialog
    header="Confirmation"
    rejectButtonStyleClass="p-button-text"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '50vw' }"
></p-confirmdialog>
